import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";

@Injectable({
    providedIn: "root",
})
export class BillingService {
    constructor(private apiService: ApiService) {}

    public getMonthlyInvoices(contractId: string) {
        return this.apiService.callServicePostToCollection("invoice.getMonthlyInvoicesList", { contractId });
    }

    public getTariffFiles(args) {
        return this.apiService.callServicePostToCollection("imageManagement.getFileReferences", args);
    }
}
